// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__3rygl","author":"Table_author__3Du_v","authorImage":"Table_authorImage__1srmO","unreadRow":"Table_unreadRow__3c1TP"};